import i18n from '@/utils/i18n';
import React from 'react';
import { ACTION_SHEET_MAX_HEIGHT, SCREEN_PADDING } from '@/styles';
import { AddPartitionItemsList } from './add-partition-items-list';
import { BaseActionSheet } from '@/components/base-action-sheet';
import { createHeaderShadow } from '@/components/navigation-header-content';
import { createStyles } from '@/contexts/theme-context';
import { ItemSearchInput } from '@/components/item-search-input';
import { NO_PARTITION_NAME } from '@/contexts/multi-order-guide-items-context-provider';
import { Partition } from '@/hooks/use-edit-order-guide-reducer';
import { Position } from '@/contexts/toast-context';
import { SearchSortOrder } from '@/contexts/user-context';
import { useSearchVariantPacks } from '@/hooks/use-search-variant-packs';
import { View } from 'react-native';

export interface Props {
  initialSearchText?: string;
  onClose: () => void;
  selectedPartition: Partition;
}

export const AddPartitionItemsActionSheet: React.FC<Props> = ({
  initialSearchText,
  onClose,
  selectedPartition,
}) => {
  const [styles] = useStyles();

  const { clearSearch, items, searchItemsCallback, queryLoading } =
    useSearchVariantPacks({
      initialSearchText,
      searchSource: 'edit_order_guide',
    });

  return (
    <BaseActionSheet
      contentContainerStyle={styles.contentContainer}
      isVisible
      modalStyle={styles.modal}
      onClose={onClose}
      title={i18n.t('add_items_to_group', {
        groupName: selectedPartition.partitionName || NO_PARTITION_NAME,
      })}
      toastPosition={Position.BOTTOM}
    >
      <AddPartitionItemsList
        contentContainerStyle={styles.listContentContainer}
        items={items}
        selectedPartition={selectedPartition}
      />
      <View style={styles.header}>
        <ItemSearchInput
          clearSearch={clearSearch}
          containerStyle={styles.searchInputContainer}
          initialSearchText={initialSearchText}
          loading={queryLoading}
          onSearchItems={(query) =>
            searchItemsCallback(query, SearchSortOrder.Relevance)
          }
        />
      </View>
    </BaseActionSheet>
  );
};

const useStyles = createStyles((theme) => ({
  contentContainer: {
    flex: 1,
    // Reverse so the header shadow renders
    flexDirection: 'column-reverse',
    paddingHorizontal: 0,
  },
  header: {
    ...createHeaderShadow(theme),
    paddingBottom: 16,
    paddingHorizontal: SCREEN_PADDING,
  },
  listContentContainer: {
    paddingHorizontal: 16,
  },
  modal: {
    flex: 1,
    maxHeight: ACTION_SHEET_MAX_HEIGHT,
  },
  searchInputContainer: {
    backgroundColor: theme.colors.background,
  },
}));
